import { AlertCircle } from "lucide-react";

// Bannière générique affichée quand un service backend autre que l'auth
// (integration_service, delivery_service, marketplace_service) est
// injoignable — ne redirige jamais vers le login, l'utilisateur reste dans
// l'app tant que auth.teqa.net répond.
const ServiceUnavailable = ({ label = "Ce service", onRetry }) => (
  <div className="bg-rose-50 dark:bg-rose-500/10 border border-rose-200 dark:border-rose-500/30 rounded-xl p-6 text-center">
    <AlertCircle size={32} className="mx-auto text-rose-500 dark:text-rose-400 mb-2" />
    <p className="text-rose-700 dark:text-rose-400 font-medium">
      {label} est indisponible pour le moment
    </p>
    <p className="text-sm text-rose-500 dark:text-rose-400/80 mt-1">
      Merci de réessayer dans quelques instants.
    </p>
    {onRetry && (
      <button
        onClick={onRetry}
        className="mt-3 px-4 py-2 bg-rose-600 text-white rounded-lg text-sm hover:bg-rose-700"
      >
        Réessayer
      </button>
    )}
  </div>
);

export default ServiceUnavailable;
